import { joinURL } from "ufo";

export function getImage(src: string) {
	const runtimeConfig = useRuntimeConfig();
	return {
		url: joinURL(`https://prod.kipem.net/global/media/entity/d/l/`, src),
	};
}
